import axios from "axios";
import baseURL from "./../api";
class MerchantsService {

    getMerchants() {
        return axios.get(`${baseURL}/merchant`);
    }
    registerMerchant(data) {
        return axios.post(`${baseURL}/merchant`,data);
    }
    suspendMerchant(data) {
      return axios.post(`${baseURL}/merchant/suspend`,data);
    }
    resumeMerchant(data) {
      return axios.post(`${baseURL}/merchant/resume`,data);
    }
    deleteMerchantData(id) {
      return axios.delete(`${baseURL}/merchant/${id}`);
    }
    getMerchantDetails(id) {
      return axios.get(`${baseURL}/merchant/${id}`);
  }
  updateMerchant(id,data) {
    return axios.patch(`${baseURL}/merchant/${id}`, data);
  }
  getMerchantUsers(id) {
    return axios.get(`${baseURL}/users/dropdown?customerId=${id}`);
  }
}
export default new MerchantsService();